<div class="landing-v2 overflow-hidden">
  <div class="home__page">
    <div class="main-container">
      <main id="middle" class="middle__sec">
        <section class="home__hero relative">
          <div id="first-background">
            <img src="assets/assets-site/images/landing-v2/bg-1.png" alt="" class="w-full" />
          </div>
          <div class="relative hidden md:block">
            <div id="img-hero">
              <img src="assets/assets-site/images/landing-v2/hero.png" alt="" class="w-full" />
            </div>
          </div>
          <div class="container relative">
            <div class="row">
              <div class="col-lg-7">
                <div class="hero__caption">
                  <span class="tagline uppercase text-landing-green-400"
                    >Un outil pour ta réussite</span
                  >
                  <h1 i18n class="title text-[37px] md:text-[48px] leading-normal">
                    Réussis ton <span class="text-landing-primary">année PASS</span> avec la méthode
                    leader des études médicales
                  </h1>
                </div>
                <div
                  class="mt-8 bg-white border border-landing-coolGray-200 rounded-xl shadow-xlLanding p-8 grid md:grid-cols-[110px_auto] gap-8"
                >
                  <div class="bg-landing-coolGray-50 p-2">
                    <img src="assets/assets-site/images/landing-v2/edn.svg" alt="" class="svg" />
                  </div>
                  <div class="text-18 text-landing-coolGray-600 classic-grid">
                    <span class="text-20 text-landing-blueRibbon-800 font-bold"
                      >Créé par EDN.fr</span
                    >
                    <span
                      >Leader des études médicales de la 2ème à la 6ème annee de médecine depuis 10
                      ans.</span
                    >
                    <span class="font-bold">165 000 étudiants en médecine depuis 2013 !</span>
                  </div>
                </div>
                <!-- nnkitodo [pass] activer -->
                <!-- <div class="mt-8">
                    Commencer ma préparation / Essai gratuit
                  </div> -->
                <div class="h-[100px]"></div>
                <div class="mt-8 flex gap-4 text-16 whitespace-nowrap flex-wrap">
                  <div class="flex gap-2 items-center">
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="16"
                      class="text-landing-green-400"
                    ></app-svg-icon>
                    <span>Des entraînements ciblés</span>
                  </div>
                  <div class="flex gap-2 items-center">
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="16"
                      class="text-landing-green-400"
                    ></app-svg-icon>
                    <span>Une progression visible</span>
                  </div>
                  <div class="flex gap-2 items-center">
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="16"
                      class="text-landing-green-400"
                    ></app-svg-icon>
                    <span>Une réussite garantie</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="relative md:hidden">
            <div id="img-hero">
              <img src="assets/assets-site/images/landing-v2/hero.png" alt="" class="w-full" />
            </div>
          </div>
        </section>
        <section class="relative">
          <div class="container no-padding-mobile">
            <h2 class="text-30 font-bold text-landing-coolGray-700 px-4 md:px-0">
              Pourquoi choisir ednPASS ?
            </h2>
            <div class="mt-8 bg-pourquoi-pass md:rounded-[24px] p-[32px] grid md:grid-cols-4 gap-8">
              <div class="bg-white p-4 rounded-[8px]">
                <div
                  class="bg-landing-primary rounded-[8px] flex items-center justify-center h-[28px] w-[28px]"
                >
                  <img src="assets/assets-site/images/landing-v2/academic-cap.svg" alt="" />
                </div>
                <div class="mt-4 text-16">
                  Plateforme ultra-complète : cours, QCM, examens blancs
                </div>
              </div>
              <div class="bg-white p-4 rounded-[8px]">
                <div
                  class="bg-landing-primary rounded-[8px] flex items-center justify-center h-[28px] w-[28px]"
                >
                  <img src="assets/assets-site/images/landing-v2/light-bulb.svg" alt="" />
                </div>
                <div class="mt-4 text-16">
                  Progression personnalisée grâce à l’intelligence artificielle
                </div>
              </div>
              <div class="bg-white p-4 rounded-[8px]">
                <div
                  class="bg-landing-primary rounded-[8px] flex items-center justify-center h-[28px] w-[28px]"
                >
                  <img src="assets/assets-site/images/landing-v2/users.svg" alt="" />
                </div>
                <div class="mt-4 text-16">Coaching et suivi individuel de votre performance</div>
              </div>
              <div class="bg-white p-4 rounded-[8px]">
                <div
                  class="bg-landing-primary rounded-[8px] flex items-center justify-center h-[28px] w-[28px]"
                >
                  <img src="assets/assets-site/images/landing-v2/trending-up.svg" alt="" />
                </div>
                <div class="mt-4 text-16">Statistiques détaillées et comparaison nationale</div>
              </div>
            </div>
          </div>
        </section>

        <section class="my-8 md:my-32 relative">
          <div id="second-background">
            <img src="assets/assets-site/images/landing-v2/bg-2.png" alt="" class="w-full" />
          </div>

          <div class="container relative">
            <div class="mx-auto max-w-[950px] grid md:grid-cols-2 gap-8 md:gap-16">
              <div class="grid gap-8">
                <h2 class="text-36 font-bold">Ce que vous obtenez avec notre préparation PASS</h2>
                <div class="grid md:grid-cols-2 gap-8 text-16">
                  <div
                    class="bg-landing-blueRibbon-50 p-4 rounded-[16px] grid grid-cols-[auto_1fr] gap-4 items-start"
                  >
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="20"
                      class="text-landing-primary mt-2"
                    ></app-svg-icon>
                    <span>Des examens avec classement au sein de ta faculté</span>
                  </div>
                  <div
                    class="bg-landing-blueRibbon-50 p-4 rounded-[16px] grid grid-cols-[auto_1fr] gap-4 items-start"
                  >
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="20"
                      class="text-landing-primary mt-2"
                    ></app-svg-icon>
                    <span>Des fiches ultra-concentrées et pertinentes</span>
                  </div>
                  <div
                    class="bg-landing-blueRibbon-50 p-4 rounded-[16px] grid grid-cols-[auto_1fr] gap-4 items-start"
                  >
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="20"
                      class="text-landing-primary mt-2"
                    ></app-svg-icon>
                    <span>Une module d’entrainement poussé à l’IA</span>
                  </div>
                  <div
                    class="bg-landing-blueRibbon-50 p-4 rounded-[16px] grid grid-cols-[auto_1fr] gap-4 items-start"
                  >
                    <app-svg-icon
                      icon="check-circle"
                      [isV2Icon]="true"
                      [width]="20"
                      class="text-landing-primary mt-2"
                    ></app-svg-icon>
                    <span>Analyse des performances en temps réel</span>
                  </div>
                </div>
              </div>
              <div class="relative">
                <img
                  src="assets/assets-site/images/landing-v2/obtenez.png"
                  alt=""
                  class="static md:absolute top-0 right-0 -bottom-[100px] max-w-full"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="my-8 md:my-32 relative">
          <div class="container">
            <div class="mx-auto max-w-[950px] grid md:grid-cols-2 gap-8 md:gap-16">
              <div class="md:order-last">
                <div class="grid gap-8 text-landing-text">
                  <h2 class="text-36 font-bold">
                    Une méthode qui a déjà fait ses preuves depuis 2013
                  </h2>
                  <span>Plateforme ultra-complète : cours, QCM, examens blancs</span>
                  <div class="flex items-center gap-4">
                    <span class="text-20 font-bold text-landing-blueRibbon-800">Créé par</span>
                    <img
                      src="assets/assets-site/images/landing-v2/edn-horizontal.png"
                      alt=""
                      class="w-[112px]"
                    />
                  </div>
                  <div class="grid grid-cols-2 gap-8">
                    <div class="col-span-2 bg-landing-blueRibbon-50 p-4 rounded-[16px]">
                      <div class="text-24 font-bold text-landing-blueRibbon-900">
                        1er site de préparation de la 2ème à 6ème année de médecine
                      </div>
                      <div class="text-18">en France depuis 2013</div>
                    </div>
                    <div class="bg-landing-blueRibbon-50 p-4 rounded-[16px]">
                      <div class="text-24 font-bold text-landing-blueRibbon-900">98%</div>
                      <div class="text-18">de satisfaction</div>
                    </div>
                    <div class="bg-landing-blueRibbon-50 p-4 rounded-[16px]">
                      <div class="text-24 font-bold text-landing-blueRibbon-900">+165 000</div>
                      <div class="text-18">étudiants en médecine</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md:order-first relative">
                <img
                  src="assets/assets-site/images/landing-v2/preuves.png"
                  alt=""
                  class="static md:absolute top-[40px] left-0 -bottom-[100px] max-w-full"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="my-8 md:my-32 relative z-1">
          <div class="container no-padding-mobile">
            <div class="bg-ancrage md:rounded-xl p-4 grid md:grid-cols-2 gap-16 items-center">
              <div class="text-white md:order-last">
                <div class="text-18 font-bold mb-4">PERFORMANCE</div>
                <div class="text-30 font-bold mb-8">
                  Mémorise plus facilement avec l’Ancrage des connaissances®
                </div>
                <div class="text-18 font-light">
                  Notre logiciel d'ancrage des connaissances ® utilise un algorithme développé par
                  nos ingénieurs pour optimiser ta mémoire à long terme. L'utilisation de
                  larépétition espacée permet d'assurer un apprentissage efficace, pour ne rien
                  oublier le jour J.
                </div>
              </div>

              <div class="bg-white rounded-card md:order-first">
                <ng-lottie
                  appObserveVisibility
                  (visible)="playAnimAncrage()"
                  width="100%"
                  height="100%"
                  containerClass="box-set"
                  [options]="animAncrageOptions"
                  (animationCreated)="animAncrageCreated($event)"
                ></ng-lottie>
              </div>
            </div>
          </div>
        </section>

        <section class="my-8 md:my-32 relative">
          <div id="third-background">
            <img src="assets/assets-site/images/landing-v2/bg-1.png" alt="" class="w-full" />
          </div>

          <div class="container relative no-padding-mobile">
            <div class="mx-auto max-w-[1070px] bg-landing-coolGray-50 md:rounded-[40px] p-16">
              <h2 class="text-30 font-bold mb-4">
                <span class="text-landing-primary">ednPASS</span> t'accompagne dans les facultés
                suivantes
              </h2>

              <div class="grid md:grid-cols-[1fr_2fr] gap-16">
                <div>
                  <div class="mb-4 text-18">
                    Sélectionnez une fac ci-dessous ou cliquez sur la carte
                  </div>
                  <div class="mb-16">
                    <mat-form-field>
                      <mat-select [(ngModel)]="selectedFac" name="university">
                        <mat-option *ngFor="let fac of facs" [value]="fac">{{
                          fac.label
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="mb-4 text-20 font-bold text-landing-text">
                    {{ selectedFac.name }}
                  </div>

                  <div class="mb-4 text-18">L’université en chiffres :</div>

                  <div class="mb-16 text-16 grid gap-4">
                    <div class="flex items-start gap-2">
                      <app-svg-icon
                        icon="check-circle"
                        [isV2Icon]="true"
                        [width]="16"
                        class="text-landing-primary mt-[2px]"
                      ></app-svg-icon>
                      <span>
                        <span class="font-bold">{{ selectedFac.pass }} inscrits</span> en PASS
                      </span>
                    </div>
                    <div class="flex items-start gap-2">
                      <app-svg-icon
                        icon="check-circle"
                        [isV2Icon]="true"
                        [width]="16"
                        class="text-landing-primary mt-[2px]"
                      ></app-svg-icon>
                      <span>
                        <span class="font-bold">{{ selectedFac.mmopk }} places</span> en deuxième
                        année de MMOPK
                      </span>
                    </div>
                  </div>

                  <!-- nnkitodo [pass] activer -->
                  <!-- <div class="mt-8">
                  découvrir + entrainements ciblés +
                    Commencer ma préparation / Essai gratuit
                  </div> -->
                </div>
                <div class="hidden md:block">
                  <img src="assets/assets-site/images/landing-v2/facs.png" alt="" class="w-full" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="cmn__section tools__section relative" id="sectionOutils">
          <div id="fourth-background">
            <img src="assets/assets-site/images/landing-v2/bg-2.png" alt="" class="w-full" />
          </div>
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="block__ttl block__ttl__tools">
                  <h2 class="text-landing-text text-36 font-bold">
                    Tous les outils de votre réussite
                  </h2>
                </div>
              </div>

              <div class="tools__content__row">
                <div class="scroll__track">
                  <div class="scroll__thumb"></div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/course-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        COURS</span
                      >
                      <h2 class="block__ttl__hdng">
                        Des fiches de cours synthétiques spécifiques de ta faculté
                      </h2>
                      <p class="block__ttl__desc">
                        Des fiches claires, à jour et propres à ta fac. Apprends plus vite, mieux,
                        et avec exactement ce qu’on attend de toi aux EDN.
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimCours()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animCoursOptions"
                      (animationCreated)="animCoursCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/type-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        ANNALES DE TA FACULTE</span
                      >
                      <h2 class="block__ttl__hdng">Les annales corrigées de ta faculté</h2>
                      <p class="block__ttl__desc">
                        Les vrais sujets de ta fac, avec des corrigés fiables et clairs.
                        Entraîne-toi sur ce que tu retrouveras vraiment le jour J.
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimType()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animTypeOptions"
                      (animationCreated)="animTypeCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/type-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        EXAMEN</span
                      >
                      <h2 class="block__ttl__hdng">Des examens hebdomadaires classant</h2>
                      <p i18n class="block__ttl__desc">
                        Des types d’examens diversifiés, axés sur les principales docimologies de la
                        réforme du deuxième cycle, avec pour but de faire varier les supports
                        d’entraînement et favoriser l’apprentissage actif dans tous les domaines.
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimType2()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animTypeOptions"
                      (animationCreated)="animType2Created($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/training-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        MODULE D’ENTRAINEMENT</span
                      >
                      <h2 class="block__ttl__hdng">
                        Un module de training pour bachoter les questions type
                      </h2>
                      <p class="block__ttl__desc">
                        QCM ciblés, classés par thème, par UE et par fac. Zéro superflu : tu bosses
                        exactement ce que le concours exige. Rien d’autre.
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimTraining()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animTrainingOptions"
                      (animationCreated)="animTrainingCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div appObserveVisibility (visible)="getFeaturedTestimoniesLanding()"></div>

        <section
          *ngIf="!landingTestimonies || landingTestimonies.length"
          id="temoignages"
          class="my-8 md:my-32 relative"
        >
          <div class="container relative no-padding-mobile">
            <h3 class="text-16 font-bold text-landing-blueRibbon-600 mb-4 px-4 md:px-0">
              TÉMOIGNAGE
            </h3>
            <h2 class="text-36 font-bold text-landing-blueRibbon-950 mb-8 px-4 md:px-0">
              Ils ont utilisé la méthode EDN...
            </h2>

            <div
              class="bg-landing-coolGray-100 md:rounded-tl-[48px] md:rounded-bl-[48px] p-12 pr-0"
            >
              <div class="exams__slider overflow-hidden">
                <div #landingTestimoniesSwiper class="swiper">
                  <div class="swiper-wrapper">
                    <div *ngFor="let testimony of landingTestimonies" class="swiper-slide">
                      <div class="bg-white border border-landing-gray-300 p-6 h-full">
                        <div class="grid grid-cols-[auto_1fr] gap-4 items-center">
                          <div class="w-[52px] h-[52px]">
                            <img
                              [src]="testimony.picture"
                              alt=""
                              class="w-full h-full rounded-full object-cover"
                            />
                          </div>
                          <div>
                            <div class="text-14">{{ testimony.firstName }}</div>
                            <div class="text-12 font-bold">{{ testimony.ecnRank }}</div>
                          </div>
                        </div>
                        <div class="mt-4 italic text-14" [innerHTML]="testimony.content"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="my-8 md:my-32 relative">
          <div class="container relative">
            <div
              class="mx-auto max-w-[950px] grid md:grid-cols-[min-content_1fr] gap-8 items-start"
            >
              <div>
                <h3 class="text-16 font-bold text-landing-blueRibbon-600 mb-4">FAQ</h3>
                <h2 class="text-36 font-bold text-landing-blueRibbon-950 mb-4 whitespace-nowrap">
                  Questions fréquentes
                </h2>
                <div class="text-16">
                  Retrouvez ici les réponses aux questions les plus posées sur notre app et la
                  préparation du PASS.
                </div>
              </div>

              <div class="grid gap-8">
                <app-landing-pass-faq title="Comment fonctionne la préparation PASS ?">
                  <p>
                    Et est admodum mirum videre plebem innumeram mentibus ardore quodam infuso cum
                    dimicationum curulium eventu pendentem. haec similiaque memorabile nihil vel
                    serium agi Romae permittunt. ergo redeundum ad textum.
                  </p>
                  <p>
                    Cognitis enim pilatorum caesorumque funeribus nemo deinde ad has stationes
                    appulit navem, sed ut Scironis praerupta letalia declinantes litoribus Cypriis
                    contigui navigabant, quae Isauriae scopulis sunt controversa.
                  </p>
                </app-landing-pass-faq>

                <app-landing-pass-faq title="Est-ce compatible avec ma fac / mon tutorat ?">
                  <p>
                    Et est admodum mirum videre plebem innumeram mentibus ardore quodam infuso cum
                    dimicationum curulium eventu pendentem. haec similiaque memorabile nihil vel
                    serium agi Romae permittunt. ergo redeundum ad textum.
                  </p>
                  <p>
                    Cognitis enim pilatorum caesorumque funeribus nemo deinde ad has stationes
                    appulit navem, sed ut Scironis praerupta letalia declinantes litoribus Cypriis
                    contigui navigabant, quae Isauriae scopulis sunt controversa.
                  </p>
                </app-landing-pass-faq>

                <app-landing-pass-faq title="Est-ce que ça suffit pour réussir sans prépa privée ?">
                  <p>
                    Et est admodum mirum videre plebem innumeram mentibus ardore quodam infuso cum
                    dimicationum curulium eventu pendentem. haec similiaque memorabile nihil vel
                    serium agi Romae permittunt. ergo redeundum ad textum.
                  </p>
                  <p>
                    Cognitis enim pilatorum caesorumque funeribus nemo deinde ad has stationes
                    appulit navem, sed ut Scironis praerupta letalia declinantes litoribus Cypriis
                    contigui navigabant, quae Isauriae scopulis sunt controversa.
                  </p>
                </app-landing-pass-faq>

                <app-landing-pass-faq title="Comment suivre ma progression ?">
                  <p>
                    Et est admodum mirum videre plebem innumeram mentibus ardore quodam infuso cum
                    dimicationum curulium eventu pendentem. haec similiaque memorabile nihil vel
                    serium agi Romae permittunt. ergo redeundum ad textum.
                  </p>
                  <p>
                    Cognitis enim pilatorum caesorumque funeribus nemo deinde ad has stationes
                    appulit navem, sed ut Scironis praerupta letalia declinantes litoribus Cypriis
                    contigui navigabant, quae Isauriae scopulis sunt controversa.
                  </p>
                </app-landing-pass-faq>
              </div>
            </div>
          </div>
        </section>

        <section class="my-8 md:my-32 relative">
          <div class="container no-padding-mobile">
            <div
              class="bg-superieur md:rounded-xl grid md:grid-cols-[503px_auto] gap-16 items-center"
            >
              <div class="text-white md:order-last p-8">
                <div class="text-30 font-bold mb-4">Passe à la vitesse supérieure</div>
                <div class="text-20 mb-8">Inscrit toi et transforme ta prépa dès aujourd’hui.</div>
                <!-- nnkitodo [pass] commencer ma préparation -->
                <!-- nnkitodo [pass] logos stores + urls -->
              </div>

              <div class="rounded-card md:order-first">
                <img
                  src="assets/assets-site/images/landing-v2/superieur.png"
                  alt=""
                  class="w-full"
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer id="footer" class="footer">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-3">
              <div class="ftr__logo">
                <img src="assets/assets-site/images/landing-v2/logo.svg" alt="" class="svg" />
              </div>
            </div>
            <div class="col-lg-6">
              <ul class="ftr__links">
                <li><a i18n [routerLink]="['/legal/cgu']">CGU</a></li>
                <li><a i18n [routerLink]="['/legal/cgv']">CGV</a></li>
                <li><a i18n [routerLink]="['/legal/mentions']">Mentions légales</a></li>
                <li>
                  <a i18n [routerLink]="['/legal/confidentiality']">Politique de confidentialité</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-3">
              <div class="scl__icons">
                <a [href]="languageService.facebookUrl" target="_blank" class="scl__btn">
                  <img src="assets/assets-site/images/landing-v2/fb.svg" alt="" class="svg" />
                </a>
                <a [href]="languageService.instagramUrl" target="_blank" class="scl__btn">
                  <img src="assets/assets-site/images/landing-v2/insta.svg" alt="" class="svg" />
                </a>
                <a
                  *ngIf="languageService.tiktokUrl"
                  [href]="languageService.tiktokUrl"
                  target="_blank"
                  class="scl__btn"
                >
                  <img
                    src="assets/assets-site/images/landing-v2/socialicons.svg"
                    alt=""
                    class="svg"
                  />
                </a>
                <a
                  *ngIf="languageService.telegramUrl"
                  [href]="languageService.telegramUrl"
                  target="_blank"
                  class="scl__btn"
                >
                  <img src="assets/assets-site/images/landing-v2/telegram.svg" alt="" class="svg" />
                </a>
                <a
                  *ngIf="languageService.discordUrl"
                  [href]="languageService.discordUrl"
                  target="_blank"
                  class="scl__btn"
                >
                  <img
                    src="assets/assets-site/images/landing-v2/discord.svg"
                    alt=""
                    class="svg w-[30px]"
                  />
                </a>
              </div>
            </div>

            <div class="col-12">
              <div class="ftr__btm">
                <p class="copyright">
                  &copy; {{ (nowService.now$ | async).getFullYear() }}
                  {{ 'landing.ecnifr' | translate : { siteName: languageService.siteName } }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>
